import React, { useContext, useEffect, useState } from "react";
import "../../../assests/css/admin/AdminLogin.css";
import { AppContext } from '../../../context/Appcontext';
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

const AdminLogin = () => {
  const { baseUrl, setLoggedInAdmin } = useContext(AppContext);
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoginLoading] = useState(false);
  const [error, setError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);

  const adminLogin = (e) => {
    e.preventDefault();
    setLoginLoading(true); 
    const formData = new FormData();
    formData.append("email", email);
    formData.append("password", password);
    axios
      .post(`${baseUrl}/admin/login/adminlogin`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((response) => {
        console.log(response.data);
        if (response.data.success === true) {
          localStorage.setItem("adminEmail", response.data.admin.email);
          localStorage.setItem("admin", JSON.stringify(response.data.admin));
          setLoggedInAdmin(response.data.admin);
          setEmail("");
          setPassword("");
          navigate("/admin/dashboard");
        } else {
          Swal.fire({
            icon: "alert",
            title: "does not match",
            text: "invalid email and password ",
          });
        }
        setLoginLoading(false);
      })
      .catch((error) => {
        console.log(error);
        Swal.fire({
          icon: "alert",
          title: "does not match",
          text: "invalid email and password ",
        });
        setLoginLoading(false);
      });
  };

  const autoLogin = (savedAdmin) => {
    setLoggedInAdmin(savedAdmin);
    navigate("/admin/dashboard");
  };

  useEffect(() => {
    const savedAdmin = JSON.parse(localStorage.getItem("admin"));
    if (savedAdmin) {
      autoLogin(savedAdmin);
    }
  }, []);

  return (
    <div className="al-container">
      <div className="al-grid">
        <div className="al-brand">
          <div className="al-brand__content">
            <div className="al-brand__icon-wrap">
              <div className="al-brand__icon">🛡️</div>
            </div>
            <h1 className="al-brand__title">Admin Portal</h1>
            <p className="al-brand__subtitle">Secure Management System</p>
            <ul className="al-features">
              {[
                { icon: "🔒", text: "End-to-end encryption" },
                { icon: "🔐", text: "Multi-factor authentication" },
                { icon: "📡", text: "Real-time monitoring" },
              ].map(({ icon, text }) => (
                <li key={text} className="al-features__item">
                  <span className="al-features__icon">{icon}</span>
                  {text}
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="al-form-section">
          <div className="al-form-wrapper">
            <div className="al-form-header">
              <h2 className="al-form-header__title">Welcome Back</h2>
              <p className="al-form-header__subtitle">
                Sign in to your admin dashboard
              </p>
            </div>

            <form className="al-form" onSubmit={adminLogin}>
              {error && <div className="al-error-box">{error}</div>}

              <div className="al-form-group">
                <label className="al-label">Admin Email</label>
                <input
                  type="email"
                  className="al-input"
                  placeholder="admin@example.com"
                  value={email}
                  onChange={(e) => { setEmail(e.target.value); setError(""); }}
                  disabled={loading}
                  required
                />
              </div>

              <div className="al-form-group">
                <label className="al-label">Password</label>
                <div className="al-input-wrap">
                  <input
                    type={showPassword ? "text" : "password"}
                    className="al-input al-input--password"
                    placeholder="••••••••"
                    value={password}
                    onChange={(e) => { setPassword(e.target.value); setError(""); }}
                    disabled={loading}
                    required
                  />
                  <button
                    type="button"
                    className="al-toggle-password"
                    onClick={() => setShowPassword(!showPassword)}>
                    {showPassword ? "Hide" : "Show"}
                  </button>
                </div>
              </div>

              <div className="al-form-options">
                <label className="al-checkbox-label">
                  <input
                    type="checkbox"
                    checked={rememberMe}
                    onChange={(e) => setRememberMe(e.target.checked)}
                  />
                  <span>Remember Me</span>
                </label>
                <button type="button" className="al-forgot-link">
                  Forgot Password?
                </button>
              </div>
              <button type="submit" className="al-submit-btn" disabled={loading}>
                {loading ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                      aria-hidden="true"
                    />
                    Logging in...
                  </>
                ) : (
                  "Login"
                )}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;